import styled from '@emotion/styled';
import { TableCell, TableSortLabel } from '@mui/material';
import { LinkStyled } from '../base-components/base-componets';

interface TableCellStyledProps {
  isMobile?: boolean;
}

export const TableCellStyled = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== "isMobile",
}) <TableCellStyledProps>`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: ${({ isMobile }) => (isMobile ? "2px" : "8px")};
  font-size: 1em;
`

export const TableSortLabelStyled = styled(TableSortLabel)`
  white-space: nowrap;
`

export const RowLink = styled(LinkStyled)`
  &:hover {
    background-color: rgba(0, 0, 0, 0.08);
  }
`;